// extracted by mini-css-extract-plugin
export var statusBar = "s2Tye";